import { AddressesService } from './../../shared/services/addresses.service';
import { Address } from './../../shared/models/classes/address';
import { SitesService } from './../../shared/services/sites.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { trigger, state, style } from '@angular/animations';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';

import { DatatableBaseComponent } from '@components/datatable-base.component';
import { UiService } from '@services/ui.service';
import { MatPaginator } from '@angular/material/paginator';
import { UsersService } from '@services/users.service';

@Component({
  selector: 'app-addresses',
  templateUrl: './addresses.component.html',
  styleUrls: ['./addresses.component.scss'],
  animations: [
    trigger('detailExpand', [
      state(
        'collapsed',
        style({ height: '0px', minHeight: '0', display: 'none' }),
      ),
      state('expanded', style({ height: '*' })),
    ]),
  ],
})
export class AddressesComponent
  extends DatatableBaseComponent
  implements OnInit
{
  addresses: Address[];

  displayedColumns = [
    'name',
    'street',
    'streetNumber',
    'locality',
    'postalCode',
    'phone',
    'assignement',
    'sites',
    'tags',
    'actions',
  ];
  dataSource: MatTableDataSource<Address>;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    protected uiSrv: UiService,
    private route: ActivatedRoute,
    private addressesSrv: AddressesService,
    private _usersService: UsersService,
  ) {
    super(uiSrv);
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  ngOnInit() {
    super.ngOnInit();
    this.getRouteData();
    this.initSubscriptions();
  }

  private initTable(): void {
    this.dataSource = new MatTableDataSource(this.addresses);
    this.dataSource.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'sites': {
          item.sites.map((site) => {
            return site.name;
          });
        }
        default:
          return item[property];
      }
    };

    this.dataSource.sort = this.sort;
  }

  private getRouteData(): void {
    this.route.data.subscribe((data: { addresses: Address[] }) => {
      this.addresses = data.addresses;
      this.initTable();
    });
  }

  private initSubscriptions(): void {
    this.addSubscription(
      this.addressesSrv.addressesListChanged.subscribe((addresses) => {
        this.dataSource.data = addresses || [];
        this.dataSource.sort = this.sort;
        this.onEditFinished();
      }),
    );

    this.addSubscription(
      this._usersService.globalSelectedClientSubject.subscribe(() => {
        this.addressesSrv.getList().subscribe();
      }),
    );
  }

  delete(idAddress: string) {
    const confirmation = confirm(
      'Êtes-vous certain de vouloir supprimer cette adresse ?',
    );

    if (confirmation) {
      this.addressesSrv.delete(idAddress).subscribe(() => {
        this.uiSrv.showSnackbar('repository.addresses.deleted', true);
      });
    }
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
}
